import api from '../../api';
import { createCourse } from '../../api/courses';
import { updateAccountData } from '../../redux/slices/accountSlice';

export const courseService = {

    createCourse: async (courseData) => {},
    deleteCourse: async (courseId) => {
        try {
            const response = await api.delete(`/courses/${courseId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting course:', error);
            throw error;
        }
    },
    //Get the schedules structure for all courses
    getSchedulesDetails: async () => {
        try {
            const response = await api.get('/courses/schedules');
            return response.data;
        } catch (error) {
            console.error('Error fetching schedules details:', error);
            throw error;
        }
    },

    getCourseDetails: async (courseId) => {
        try {
            const response = await api.get(`teachers/courses/${courseId}/details`);
            return response.data;
        } catch (error) {
            console.error('Error fetching course details:', error);
            throw error;
        }
    },

    // Get course details with plan
    getCoursePlanDetails: async (courseId) => {
        try {
            const response = await api.get(`/courses/${courseId}/plan`);
            return response.data;
        } catch (error) {
            console.error('Error fetching course plan:', error);
            throw error;
        }
    },

    // Load teacher's courses and update Redux
    loadTeacherCourses: async (dispatch) => {
        try {
            const response = await api.get('/teacher/courses');
            dispatch(updateAccountData({ courses: response.data }));
            return response.data;
        } catch (error) {
            console.error('Error loading teacher courses:', error);
            throw error;
        }
    },

    // Update course details
    updateCourse: async (courseId, courseData) => {
        try {
            const response = await api.put(`/courses/${courseId}`, courseData);
            return response.data;
        } catch (error) {
            console.error('Error updating course:', error);
            throw error;
        }
    },

    // Get course subscriptions
    getCourseSubscriptions: async (courseId) => {
        try {
            const response = await api.get(`/courses/${courseId}/subscriptions`);
            return response.data;
        } catch (error) {
            console.error('Error fetching course subscriptions:', error);
            throw error;
        }
    },

    // Create new topic
    createTopic: async (courseId, topicData) => {
        try {
            const response = await api.post(`/courses/${courseId}/topics`, topicData);
            return response.data;
        } catch (error) {
            console.error('Error creating topic:', error);
            throw error;
        }
    },

    // Get course progress
    getCourseProgress: async (courseId) => {
        try {
            const response = await api.get(`/courses/${courseId}/progress`);
            return response.data;
        } catch (error) {
            console.error('Error fetching course progress:', error);
            throw error;
        }
    },

    // Update teaching plan
    updateTeachingPlan: async (courseId, planData) => {
        try {
            const response = await api.put(`/courses/${courseId}/plan`, planData);
            return response.data;
        } catch (error) {
            console.error('Error updating teaching plan:', error);
            throw error;
        }
    },

    // Get course analytics unused
    getCourseAnalytics: async (courseId) => {
        try {
            const response = await api.get(`/courses/${courseId}/analytics`);
            return response.data;
        } catch (error) {
            console.error('Error fetching course analytics:', error);
            throw error;
        }
    }
};

export default courseService;
